<template>
  <div class="modal fade" :id="'modal-dates-' + talentId" tabindex="-1" role="dialog" aria-labelledby="modal-date-applied-for" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title center">Select Your Preferred Date</h4>
        </div>
        <div class="modal-body">
          <button v-for="(date, index) in dates"
                  :key="index"
                  type="button"
                  :class="[selectedDate === date ? 'btn-primary btn-lg' : 'btn-dark', 'btn btn-block']"
                  @click="setSelectedDate(date)">
            {{ date | date($user.date_format_preference) }}
          </button>
        </div>
        <div class="modal-footer">
          <button class="btn btn-danger btn-lg pull-left" data-dismiss="modal">Cancel</button>
          <button
                  class="btn btn-primary btn-lg"
                  data-dismiss="modal"
                  @click="handleDateAppliedForCallback">
            {{ bookingIsStandardPackage || !$declineModuleEnabled ? 'Accept' : 'Apply' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
export default {
  mixins: [helpers],

  props: {
    dates: {
      required: true
    },
    comment: {
      type: Boolean,
      default: false
    },
    talentId: {
      type: Number,
      required: true
    },
    booking: {
      required: true
    }
  },

  data () {
    return {
      selectedDate: null
    }
  },

  methods: {

    /*
     * Talent has selected date
     */
    setSelectedDate (date) {
      this.selectedDate = date
    },

    /*
     * Handle talent has selected preferred date
     */
    handleDateAppliedForCallback () {
      this.$emit('input', this.selectedDate)
    }
  }
}
</script>
